import React from 'react';
import { SettingsPanelRow, SettingsColumn, SettingsItem, IconArea, LanguageIcon, SourceIcon } from './styles';

const CHANGE_LANGUAGE_ID = 'language';
const SOURCE_CATEGORY_ID = 'source';

/**
 * SettingsPanel — left categories, right options (languages or video sources).
 */
const SettingsPanel = ({
  categories,
  leftFocusIndex,
  leftSectionFocused,
  rightItems,
  rightFocusIndex,
  rightSectionFocused,
  selectedRightItemId,
  onCategoryClick,
  onRightItemClick,
}) => {
  const activeCategoryId = categories[leftFocusIndex]?.id;
  const showLanguageIcon = activeCategoryId === CHANGE_LANGUAGE_ID;
  const showSourceIcon = activeCategoryId === SOURCE_CATEGORY_ID;

  return (
    <SettingsPanelRow>
      <SettingsColumn sectionFocused={leftSectionFocused}>
        {categories.map((category, index) => (
          <SettingsItem
            key={category.id}
            active={index === leftFocusIndex}
            sectionFocused={leftSectionFocused}
            onClick={() => onCategoryClick(index)}
          >
            {category.label}
          </SettingsItem>
        ))}
      </SettingsColumn>

      <SettingsColumn sectionFocused={rightSectionFocused}>
        {rightItems.map((item, index) => (
          <SettingsItem
            key={item.id}
            active={index === rightFocusIndex}
            selected={
              selectedRightItemId != null &&
              item.id === selectedRightItemId &&
              index !== rightFocusIndex
            }
            sectionFocused={rightSectionFocused}
            onClick={() => onRightItemClick(index)}
          >
            {item.label}
          </SettingsItem>
        ))}
      </SettingsColumn>

      <IconArea>
        {showLanguageIcon && (
          <LanguageIcon>
            <path
              className='language-icon__panel'
              d='M0 60C0 26.8629 26.8629 0 60 0H250C283.137 0 310 26.8629 310 60V250C310 283.137 283.137 310 250 310H60C26.8629 310 0 283.137 0 250V60Z'
            />
            <path
              className='language-icon__glyph'
              d='M167.055 217L197.194 139.5L227.333 217M174.59 199.778H219.798M80.9443 113.667H141.222M141.222 113.667H158.444M141.222 113.667C141.222 127.703 134.394 147.474 121.942 162.362M121.942 162.362C113.58 172.394 102.653 180.187 89.5554 182.555M121.942 162.362L98.1666 139.5M121.942 162.362L142.944 182.555M119.694 112.099V96.4443'
            />
          </LanguageIcon>
        )}
        {showSourceIcon && (
          <SourceIcon>
            <path
              className='source-icon__panel'
              d='M0 60C0 26.8629 26.8629 0 60 0H250C283.137 0 310 26.8629 310 60V250C310 283.137 283.137 310 250 310H60C26.8629 310 0 283.137 0 250V60Z'
            />
            <path
              className='source-icon__glyph'
              d='M82 108H228C238.493 108 247 116.507 247 127V183C247 193.493 238.493 202 228 202H82C71.5066 202 63 193.493 63 183V127C63 116.507 71.5066 108 82 108Z'
            />
            <path className='source-icon__glyph' d='M118 202V224M192 202V224M104 224H206' />
            <path className='source-icon__play' d='M142 140V170L178 155L142 140Z' />
          </SourceIcon>
        )}
      </IconArea>
    </SettingsPanelRow>
  );
};

export default SettingsPanel;
